
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class SysParaGrid extends Serenity.EntityGrid<SysParaRow, any> {
        protected getColumnsKey() { return SysParaColumns.columnsKey; }
        protected getDialogType() { return SysParaDialog; }
        protected getIdProperty() { return SysParaRow.idProperty; }
        protected getInsertPermission() { return SysParaRow.insertPermission; }
        protected getLocalTextPrefix() { return SysParaRow.localTextPrefix; }
        protected getService() { return SysParaService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}